export default __webpack_public_path__ + "static/api-52b34a25629353d62734d5ccbd90653d.svg";